import HTTP from '@/utils/http'

class Study2Model extends HTTP {
  static COMMAND = {
    LEARN: 'LEARN',
    RESULT: 'RESULT',
    TIME: 'TIME',
    LEARN_FINISH: 'LEARN_FINISH',
    REPEAT: 'REPEAT',
    PAUSE: 'PAUSE',
  }

  /**
   * 获取关卡列表
   * @see https://yapi.dayuan1997.com/project/55/interface/api/3551
   */
  lessons(params) {
    return this.get({
      url: '/study/lesson/list',
      params,
    })
  }

  /**
   * 获取故事/情景段/元素列表
   * @param {*} params
   */
  lessonItems(params) {
    return this.get({
      url: '/study/lesson/find',
      params,
    })
  }

  /**
   * 获取故事/情景段/元素结果
   * @param {*} params
   */
  result(params) {
    return this.get({
      url: '/study/lesson/result',
      params,
    })
  }

  /**
   * 获取故事/情景段/元素结果
   * @param {*} params
   */
  resultV2(params) {
    return this.get({
      url: '/study/lesson/result/v2',
      params,
    })
  }

  /**
   * 上报
   * @param {*} data
   */
  upload(data) {
    return this.post({
      url: '/study/lesson/upload',
      data,
    })
  }

  /**
   * 下一个节点
   */
  nextNode(params) {
    return this.get({
      url: '/study/lesson/current',
      params,
    })
  }

  /**
   * 整听整看
   */
  previewData(params) {
    return this.get({
      url: '/study/lesson/preview',
      params,
    })
  }

  /**
   * 整听整看详情
   */
  previewInfo(id) {
    return this.get({
      url: '/study/lesson/preview/info',
      params: {
        id,
      },
    })
  }

  /**
   * 排行榜/完成榜
   */
  rank(params) {
    return this.get({
      url: '/study/lesson/rank',
      params,
    })
  }

  /**
   *
   * 点赞/提醒 cmd:LIKE/REMIND
   */
  rankOpr(params) {
    return this.get({
      url: '/study/lesson/rank/user',
      params,
    })
  }

  /**
   * 整听整看开始/完成
   * @param {number} id
   * @param {string} sourceId
   * @returns 
   */
  uploadPreview(params) {
    return this.get({
      url: '/study/lesson/preview/finish',
      params
    })
  }

  /**
   * @description 获取本周心法集
   * @see https://yapi.dayuan1997.com/project/55/interface/api/9851
   *
   */
  getLessonAudios(stage) {
    return this.get({
      url: '/study/lesson/audioList',
      params: {
        type: stage,
      }
    })
  }

  /**
   * @description 行为 - 指读行为收集
   * @see https://yapi.dayuan1997.com/project/11/interface/api/10156
   *
   */
  recordPlayData(data) {
    return this.post({
      url: '/study/behavior/read/finger',
      data,
    })
  }
}

const http = new HTTP()

/**
 * @description 心法集播放行为收集
 * @see https://yapi.dayuan1997.com/project/11/interface/api/10156
 *
 */
export function apiRecordXinfaPlayData(data) {
  return http.post({
    url: '/study/behavior/read/finger',
    data,
  })
}

/**
 * @description 心法集播放行为收集
 * @see https://yapi.dayuan1997.com/project/55/interface/api/10266
 *
 */
export function apiRecordPlayData(data) {
  return http.post({
    url: '/study/behavior/collect',
    data,
  })
}

/**
 * @description 课程 - 获取读音游戏单词列表
 * @see https://yapi.dayuan1997.com/project/55/interface/api/10641
 *
 */
export function apiGetGameWordsList(id) {
  return http.get({
    url: '/study/lesson/read/list',
    params: {
      id,
    },
  })
}

/**
 * 关卡重置券使用
 * https://yapi.dayuan1997.com/project/55/interface/api/10806
 */
export function apiUseResetCoupon(params) {
  return http.get({
    url: '/study/prop/reset',
    params,
  })
}

/**
 * 关卡增加次数券使用
 * https://yapi.dayuan1997.com/project/55/interface/api/10806
 */
export function apiUseAddCoupon(params) {
  return http.get({
    url: '/study/prop/num',
    params,
  })
}

/**
 * 延迟锁课券使用
 * https://yapi.dayuan1997.com/project/55/interface/api/11551
 */
export function apiUseDelayCoupon(params) {
  return http.get({
    url: '/study/prop/delay/week/lock',
    params,
  })
}

export default Study2Model
